import { FC, HTMLAttributes, ReactNode } from "react";
import { clsx } from "clsx";

import HtmlText from "../common/HtmlText";
import CTASquareBox, { ICtaSquareBox } from "./CTASquareBox";
import { isEmpty } from "lodash";

// -------------------------------------------------------------------------------

export type IServiceListSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  ctaSquareBox?: ICtaSquareBox;
  stages?: {
    heading?: string;
    description?: ReactNode;
  }[];
};

const ServiceListSection: FC<IServiceListSectionProps> = (props) => {
  const { heading, ctaSquareBox, description, stages, className, ...other } =
    props;

  return (
    <section
      className={clsx("container py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      <div className="lg:flex">
        {heading && (
          <div className="w-full flex-[1_0_auto] border-t-2 border-t-primary-900 pt-5 lg:w-60 lg:pt-7 xl:w-[276px]">
            <h3 className="mb-5 text-base font-normal text-black-900 lg:text-base xl:text-h6">
              {heading}
            </h3>
          </div>
        )}

        <div>
          <div
            className={clsx(
              "lg:flex",
              !isEmpty(stages) && "pb-4 md:pb-5 lg:pb-8 xl:pb-12",
            )}
          >
            {description && (
              <div className="w-full lg:border-t-2 lg:border-t-[#D9D9D9]">
                <HtmlText className="py-4 lg:px-5 lg:pt-5 xl:px-7 xl:pt-7">
                  {description}
                </HtmlText>
              </div>
            )}

            {ctaSquareBox && (
              <CTASquareBox
                heading={ctaSquareBox.heading}
                description={ctaSquareBox.description}
                button={ctaSquareBox.button}
              />
            )}
          </div>

          {stages?.map((item, idx) => (
            <div
              key={idx}
              className="w-full border-t-2 border-t-[#D9D9D9] pb-5 last:pb-0 lg:pb-8 xl:pb-[50px]"
            >
              {(item.heading || item.description) && (
                <div className="ml-3 pt-3 md:ml-5 md:flex lg:ml-8 lg:pt-5 xl:ml-10 xl:pt-7">
                  {item.heading && (
                    <h6 className="mb-4 flex-[1_0_auto] text-[18px] font-normal text-black-900 md:mb-0 md:w-[120px] xl:w-[175px] xl:text-h6">
                      {item.heading}
                    </h6>
                  )}
                  {item.description && (
                    <div className="ml-3 lg:ml-6 xl:ml-8">
                      <HtmlText className="prose-p:text-h6">
                        {item.description}
                      </HtmlText>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceListSection;
